import { Navigate } from 'react-router-dom';
import { Route } from '../types/use-routes.interface';

export const makeCommonScreen = (): Route => ({
  path: '*',
  element: <Navigate to="/home" replace />,
});
